import React from 'react';
import { MiniWizardView } from './core/MiniWizardView';
import { useMiniWizard } from './core/useMiniWizard';
import { Route } from 'react-router';

export const MiniWizardRouteHandler: React.FC = () => {
    return (
        <Route path="/q/:wizardKey" render={routeParams => {
            return (
                <MiniWizardPage key={routeParams.match.params.wizardKey}
                    wizardKey={routeParams.match.params.wizardKey}
                    params={new Map(new URLSearchParams(routeParams.location.search))}
                />
            );
        }} />
    );
};

export const MiniWizardPage: React.FC<{ wizardKey: string; params: Map<string, string>; }> = ({ wizardKey, params }) => {
    const miniWizardViewModel = useMiniWizard(wizardKey, params);

    if (!miniWizardViewModel){
        return null;
    }

    return (
        <MiniWizardView key={wizardKey} miniWizard={miniWizardViewModel} />
    );
};
